module.exports = __webpack_public_path__ + "media/svg/hr-434291d3.svg";